// extracted by mini-css-extract-plugin
export var defaultFont = "index-module--default-font--ZQ7QG";
export var fontWeight500 = "index-module--font-weight-500--nKZJ+";
export var codeFont = "index-module--code-font--EaoZi";
export var textGreen = "index-module--text-green--VuV7N";
export var clearButtonStyles = "index-module--clear-button-styles--RT9Ko";
export var header = "index-module--header--QFPWB";
export var code_block = "index-module--code_block--RDIg3";